import {pageInfo, initPage, saveData,initUpdate, editData,deleteData,exportData} from './../api';
import { selectBoxCondition,selectOrderType} from '../../../../api';
const soldto = {
  namespaced: true,
  state: {
    total:0,
    pageResp:null,
    addResp: null,
    editResp: null,
    initPageObj: null,
    initUpdateObj: null,
    deleteResp: null,
    boxConditionObj:null,
    orderTypeObj: null,
    exportObj: null,
  },
  mutations: {

    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    INIT_PAGE(state,data) {
      state.initPageObj = data.obj || {};
    },
    SAVE_DATA(state,data){
      state.addResp = data;
    },
    INIT_UPDATE(state,data) {
      state.initUpdateObj = data.obj || {};
    },
    EDIT_DATA(state,data){
      state.editResp = data;
    },
    DELETE_DATA(state,data){
      state.deleteResp = data;
    },
    BOX_CONDITION(state,data){
      state.boxConditionObj = data.obj || {};
    },
    ORDER_TYPE(state,data){
      state.orderTypeObj = data.obj || {};
    },
    //导出
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },

  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //初始化页面事件
    async initPage({commit}, obj){
      let resp = await initPage(obj);
      commit('INIT_PAGE', resp);
    },
    //新增保存事件
    async saveData({commit}, obj){
      let resp = await saveData(obj);
      commit('SAVE_DATA', resp);
    },
    //初始化更新对象事件
    async initUpdate({commit}, obj){
      let resp = await initUpdate(obj);
      commit('INIT_UPDATE', resp);
    },
    //修改保存事件
    async editData({commit}, obj){
      let resp = await editData(obj);
      commit('EDIT_DATA', resp);
    },
    //删除数据事件
    async deleteData({commit}, obj){
      let resp = await deleteData(obj);
      commit('DELETE_DATA', resp);
    },
    //下拉框列表-箱况类型
    async selectBoxCondition({commit}, obj){
      let resp = await selectBoxCondition(obj);
      commit('BOX_CONDITION', resp);
    },
    //订单类型下拉框
    async selectOrderType({commit}, obj){
      let resp = await selectOrderType(obj);
      commit('ORDER_TYPE', resp);
    },
    //导出数据
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
  }
}
export default soldto



// WEBPACK FOOTER //
// ./src/page/md/soldto/store/soldto.store.js